import { Component } from '@angular/core';

@Component({
    selector: 'digitalization-tool-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent {}
